import React, { useMemo } from 'react';
import { Nav, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import * as Icons from '../Admin/AdminLogos';

const DefaultIcon = Icons.HomeLogo;

const menuItems = [
    { path: '/manager/dashboard', icon: 'HomeLogo', label: 'Home' },
    { path: '/manager/dashboard/user-management', icon: 'UserManagement', label: 'User Management' },
    { path: '/manager/dashboard/transfer-credit', icon: 'CreditLogo', label: 'Credit Management' },
    { path: '/manager/dashboard/transfer-credit-history', icon: 'SMSReport', label: 'Credit Transfer History' },
    { path: '/manager/dashboard/sms-analytics', icon: 'SmsTraffic', label: 'SMS Analytics' },
    { path: '/manager/dashboard/sms-campaign', icon: 'SMSCampaignLogo', label: 'SMS Campaign Report' },
    { path: '/manager/dashboard/sms-transaction-report', icon: 'SMSReport', label: 'SMS Transaction Report' },
];

const ManagerSidebarItems = ({ sidebarShow }) => {
    const { pathname } = useLocation();

    const renderNavItem = useMemo(() => (item) => {
        const Icon = Icons[item.icon] || DefaultIcon;

        const isActive = !item.external && pathname === item.path;
        const linkProps = item.external
            ? { as: 'a', href: item.path, target: '_blank', rel: 'noopener noreferrer' }
            : { as: Link, to: item.path };

        const content = (
            <>
                <span className="nav-icon">
                    <Icon />
                </span>
                <span className="toggle-name">{item.label}</span>
            </>
        );

        const navLink = (
            <Nav.Link {...linkProps} active={isActive}>
                {content}
            </Nav.Link>
        );

        return (
            <Nav.Item as="li" key={item.path}>
                {sidebarShow ? (
                    navLink
                ) : (
                    <OverlayTrigger
                        placement="right"
                        overlay={<Tooltip id={`nav-${item.label.toLowerCase()}`}>{item.label}</Tooltip>}
                    >
                        {navLink}
                    </OverlayTrigger>
                )}
            </Nav.Item>
        );
    }, [pathname, sidebarShow]);

    return (
        <Nav as="ul" className="responsive-scroll">
            {menuItems.map(renderNavItem)}
        </Nav>
    );
};

export default ManagerSidebarItems;
